import { createBrowserRouter, Navigate } from 'react-router-dom';

export type TierSlug = 'pita' | 'cag' | 'fmd';
export type PackSlug = 'ccp' | 'sfp' | 'pag' | 'ccp-sfp' | 'ccp-pag' | 'sfp-pag' | 'all';
export const VALID_TIERS: TierSlug[] = ['pita', 'cag', 'fmd'];
export const VALID_PACKS: PackSlug[] = ['ccp', 'sfp', 'pag', 'ccp-sfp', 'ccp-pag', 'sfp-pag', 'all'];
import PortalShell from './components/PortalShell';
import CommandCenter from './pages/CommandCenter';
import CRM           from './pages/CRM';
import Monitoring    from './pages/Monitoring';
import Cyber         from './pages/Cyber';
import Compliance    from './pages/Compliance';
import Tenants       from './pages/Tenants';
import Users         from './pages/Users';
import Recruitment   from './pages/Recruitment';
import InvestorBoard from './pages/InvestorBoard';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: PortalShell,
    children: [
      { index: true, element: <Navigate to="/command-center" replace /> },
      { path: 'command-center',         Component: CommandCenter },
      { path: 'crm',                    Component: CRM },
      { path: 'investors',              Component: InvestorBoard },
      { path: 'monitoring',             Component: Monitoring },
      { path: 'cyber',                  Component: Cyber },
      { path: 'compliance',             Component: Compliance },
      { path: 'tenants',                Component: Tenants },
      { path: 'users',                  Component: Users },
      { path: 'recruitment',            Component: Recruitment },
      { path: 'recruitment/:app_id',    Component: Recruitment },
      { path: '*', element: <Navigate to="/command-center" replace /> },
    ],
  },
]);
